import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function FotoAhoraPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Foto Ahora | Desarrollo de App Móvil y Periodismo Ciudadano | Mood Agency</title>
      <meta name="description" content="Caso de éxito Foto Ahora: Desarrollo de aplicación móvil para fotoperiodismo ciudadano en Venezuela, permitiendo compartir imágenes verificadas y combatir la desinformación." />
      <meta name="keywords" content="Foto Ahora, desarrollo de apps, aplicación móvil, periodismo ciudadano, Venezuela, fotoperiodismo, tecnología social" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal like Home */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO 2017
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            FOTO AHORA
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Periodismo ciudadano verificado: Tecnología contra la desinformación en tiempos de crisis.
          </p>
        </div>
      </section>

      {/* Key Metrics - Minimalist Grid */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">+2,480</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Fotos Compartidas</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">10k+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Interacciones</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">50+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Medios Aliados</p>
          </div>
        </div>
      </section>

      {/* The Context - Clean Typography */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            En un entorno de alta movilización social y polarización política, la ciudadanía venezolana asumió el rol de informar. Sin embargo, la democratización de la información trajo consigo el caos informativo y la viralización de noticias falsas.
          </p>
        </div>
      </section>

      {/* Visual Break - Full Width Image */}
      <section className="w-full h-[80vh] overflow-hidden">
        <img 
          src="/assets/images/portfolio/foto-ahora/header.jpg" 
          alt="Foto Ahora App Interface" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-out"
        />
      </section>

      {/* The Challenge - Minimal List */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Crisis de la<br/>Verdad
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              En la avalancha de información de las redes sociales, la veracidad se diluía. La falta de verificación permitía que imágenes falsas o descontextualizadas se viralizaran, creando confusión.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Verificación</h3>
              <p className="font-sans text-gray-500">¿Cómo certificar que una foto es actual, real y tomada en el lugar que dice ser?</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Infociudadanía</h3>
              <p className="font-sans text-gray-500">Empoderar al ciudadano común con herramientas periodísticas profesionales.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Viralidad Responsable</h3>
              <p className="font-sans text-gray-500">Facilitar la difusión de contenido veraz para combatir la desinformación en tiempo real.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution - Grid Layout */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">App de Certificación</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Desarrollamos una app móvil que incrusta metadatos visibles (fecha, hora, ubicación GPS) directamente en la fotografía al momento de la captura.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Combate a la Distorsión</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Al garantizar la procedencia y temporalidad de la imagen, evitamos que fotos de otros contextos o fechas sean usadas para manipular la opinión pública.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Integración Social</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Diseñada para la inmediatez, la app permite compartir la "foto verificada" directamente en Twitter y Facebook con un solo toque.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact - Minimal Text */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Reconocimiento</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Más de 50 medios y blogs influyentes, incluyendo CNN en Español y FayerWayer, recomendaron la herramienta como esencial para el periodismo ciudadano responsable."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
